/**
 * Vuex module for centralized constants accessible via getters
 */
import { FILE_ACTION_TYPES, FILE_STATUS } from '../../constants/actionTypes'

const state = {
  actionTypes: FILE_ACTION_TYPES,
  fileStatus: FILE_STATUS
}

const getters = {
  // File Action Types
  actionTypes: (state) => state.actionTypes,
  fileStatus: (state) => state.fileStatus,

  // User types
  userAvatarType: (state) => state.actionTypes.avatar.name,

  // Project types
  projectBannerType: (state) => state.actionTypes.project_banner.name,
  projectLogoType: (state) => state.actionTypes.project_image.name,
  projectResourceType: (state) => state.actionTypes.project_resource.name,

  // Organization types
  organizationBannerType: (state) => state.actionTypes.organization_banner.name,
  organizationLogoType: (state) => state.actionTypes.organization_logo.name,
  organizationResourceType: (state) => state.actionTypes.organization_resource.name,

  // Observation types
  observationRecordType: (state) => state.actionTypes.observation_record.name,
  observationImageType: (state) => state.actionTypes.observation_image.name,

  // Forum types
  forumFileType: (state) => state.actionTypes.forum_file.name,

  // Extension getters
  userAvatarExtensions: (state) => state.actionTypes.avatar.extensions,
  projectBannerExtensions: (state) => state.actionTypes.project_banner.extensions,
  projectLogoExtensions: (state) => state.actionTypes.project_image.extensions,
  projectResourceExtensions: (state) => state.actionTypes.project_resource.extensions,
  organizationBannerExtensions: (state) => state.actionTypes.organization_banner.extensions,
  organizationLogoExtensions: (state) => state.actionTypes.organization_logo.extensions,
  organizationResourceExtensions: (state) => state.actionTypes.organization_resource.extensions,
  observationRecordExtensions: (state) => state.actionTypes.observation_record.extensions,
  observationImageExtensions: (state) => state.actionTypes.observation_image.extensions,
  forumFileExtensions: (state) => state.actionTypes.forum_file.extensions,

  // Accept getters (for VueUploadComponent)
  userAvatarAccept: (state) => state.actionTypes.avatar.accept,
  projectBannerAccept: (state) => state.actionTypes.project_banner.accept,
  projectLogoAccept: (state) => state.actionTypes.project_image.accept,
  organizationBannerAccept: (state) => state.actionTypes.organization_banner.accept,
  organizationLogoAccept: (state) => state.actionTypes.organization_logo.accept,
  observationRecordAccept: (state) => state.actionTypes.observation_record.accept,
  observationImageAccept: (state) => state.actionTypes.observation_image.accept,
  forumFileAccept: (state) => state.actionTypes.forum_file.accept,
}

export default {
  namespaced: true,
  state,
  getters
}
